module.exports = __webpack_public_path__ + "static/media/bg.4d75f74a.png";